export enum DancePartnerGenderEnum {
    MALE = "MALE",
    FEMALE = "FEMALE",
    DIVERSE = "DIVERSE",
    NOT_IMPORTANT = "NOT_IMPORTANT"
}
